<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h2>Project: <code class="text-center text-warning">{{projectName}}</code></h2>
        </div>
        <div class="card-body">
          <div class="row">
            <div v-if="years.length > 1" class="col-12">
              <year-selector :years="years" :selected="selectedYear" @change="changeYear" />
            </div>
          </div>
          <div v-if="dataShow" class="row">
            <div class="col-12">
              <div style="display: inline-block; max-width: 100px; float: left; z-index: 100">
                <div>
                  <div class="handsontable table-responsive" style="overflow: hidden; z-index: 100" id="datesTitle">
                    <table class="htCore">
                      <colgroup>
                        <col style="width: 100px;">
                      </colgroup>
                      <thead>
                      <tr>
                        <th>
                          <div class="relative">
                            <span class="colHeader">Date</span>
                          </div>
                        </th>
                      </tr>
                      <tr>
                        <th>
                          <div class="relative">
                            <span class="colHeader"><b>Total</b></span>
                          </div>
                        </th>
                        <th v-for="(article, index) in totalIncome" :key="index">
                          <div class="relative">
                            <span class="colHeader"><b>{{formatter.format(article)}}</b></span>
                          </div>
                        </th>
                      </tr>
                      </thead>
                    </table>
                  </div>
                  <div class="handsontable table-responsive" style="max-height: 680px; overflow: hidden; background-color: white; margin-top: -10px; z-index: 100" id="datesValue">
                    <table class="htCore">
                      <colgroup>
                        <col style="width: 100px;">
                      </colgroup>
                      <tbody>
                      <tr v-for="(record, index) in incomeTable" :key="index">
                        <td class=""><input type="text" class="cell" v-model="record.date"></td>
                      </tr>
                      <tr v-for="(record, index) in newIncomesTable" :key="'new' + index+newRows+1">
                        <td class=""><input type="text" class="cell" v-model="record.date"></td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div style="margin-left: -1px; display: inline-block;" id="divValues" >
                <div class="handsontable table-responsive" style="overflow: hidden" id="incomeTableTitles">
                  <table class="htCore">
                    <colgroup id="titles">
                      <col style="width: 300px;" v-for="(article, index) in articles" :key="index">
                    </colgroup>
                    <thead>
                    <tr>
                      <th v-for="(article, index) in articles" :key="index">
                        <div class="relative">
                          <span class="colHeader">{{article.name}}</span>
                        </div>
                      </th>
                    </tr>
                    <tr>
                      <th v-for="(article, index) in totalIncome" :key="index">
                        <div class="relative">
                          <span class="colHeader"><b>{{formatter.format(article)}}</b></span>
                        </div>
                      </th>
                    </tr>
                    </thead>
                  </table>
                </div>
                <div @scroll="scrollingY" @keyup="keyMonitor" class="handsontable table-responsive" style="max-height: 680px; margin-top: -10px; background-color: white;" id="incomeTableValues">
                  <table class="htCore">
                    <colgroup>
                      <col style="width: 300px;" v-for="(article, index) in articles" :key="index">
                    </colgroup>
                    <tbody>
                    <tr v-for="(record, index) in incomeTable" :key="index">
                      <td v-for="(article, index) in articles" :key="index">
                        <input type="text" class="cell" v-model="record[getArticlePropertyName(article.name)]['value']" v-on:change="addNewInc($event, getArticlePropertyName(article.name))">
                      </td>
                    </tr>
                    <tr v-for="(record, index) in newIncomesTable" :key="'new' + index+newRows+1">
                      <td v-for="(article, index) in articles" :key="index">
                        <input type="text" class="cell" v-model="record[getArticlePropertyName(article.name)]['value']" v-on:change="addNewInc($event, getArticlePropertyName(article.name))">
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-xl-2" style="margin-top: 15px">
              <base-button class="clock-button" size="lg" simple type="success" @click="sentIncomeTable">Save table</base-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from "axios";
import {setCookie, url} from "../plugins/axios";
import {formatter} from "../plugins/axios";
import NotificationTemplate from "./Notifications/NotificationTemplate";
import YearSelector from "../components/YearSelector";
export default {
  name: "IncomesExpenses",
  components: {YearSelector},
  data(){
    return{
      incomeTable: [],
      incomeTableOld: [],
      newIncomesTable:[],
      incomeTableFull: {},
      incomeTableFullOld: {},
      totalIncomeFull: {},
      newRows:0,maxRows:500,
      totalIncome: {},
      currentProject: 0,
      formatter: formatter,
      projectName: '',
      dataShow: false,
      articles: [],
      years: [],
      selectedYear: 2022,
      data: {},
      preparedData: {}
    }
  },
  watch: {
    selectedYear(newValue) {
      this.setTableData();
    }
  },

  methods:{
    onResize(event){
      let width = document.body.clientWidth - 180;
      if (document.body.clientWidth > 990) {
        width -= 250;
      }
      if (document.body.clientWidth > 768) {
        width -= 30;
      }
      document.querySelector("#divValues").setAttribute("style", "margin-left: -1px; display: inline-block; width: " + width + "px");
    },
    keyMonitor(event) {
      if (event.key === 'ArrowRight'){
        if (event.target.parentElement.nextElementSibling !== null){
          event.target.parentElement.nextElementSibling.children.item(0).focus();
        }
        else if(event.target.parentElement.parentElement.nextElementSibling !== null){
          event.target.parentElement.parentElement.nextElementSibling.children.item(0).children.item(0).focus();
        }
      }
      if (event.key === 'ArrowLeft'){
        if (event.target.parentElement.previousElementSibling !== null){
          event.target.parentElement.previousElementSibling.children.item(event.target.parentElement.previousElementSibling.children.length - 1).focus();
        }
        else if(event.target.parentElement.parentElement.previousElementSibling !== null){
          event.target.parentElement.parentElement.previousElementSibling.children.item(event.target.parentElement.parentElement.previousElementSibling.children.length - 1).children.item(0).focus();
        }
      }
      if (event.key === 'ArrowUp'){
        let index = Array.from(event.target.parentElement.parentElement.children).indexOf(event.target.parentElement);
        if (event.target.parentElement.parentElement.previousElementSibling !== null) {
          event.target.parentElement.parentElement.previousElementSibling.children.item(index).children.item(0).focus();
        }
      }
      if (event.key === 'ArrowDown'){
        let index = Array.from(event.target.parentElement.parentElement.children).indexOf(event.target.parentElement);
        if (event.target.parentElement.parentElement.nextElementSibling !== null) {
          event.target.parentElement.parentElement.nextElementSibling.children.item(index).children.item(0).focus();
        }
      }
    },
    async getArticles(id){
      await axios
        .get(url + 'articles-short/' + id + '/',
          {
            withCredentials:'include',
            crossDomain:true
          })
        .then((response) => {
          if (response.data.error === ''){
            this.articles = response.data.result;
          }
          else{
            if (response.data.error === 'Session is over'){
              setCookie('Authentication','Failed',1);
              this.$router.push('/');
            }
            else{
              this.notifyVue('danger',response.data.error);
            }
          }
        })
        .catch((error) => {
          this.notifyVue('danger',error);
        });
    },
    async getIncomes(id){
      await axios
        .get(url + 'incomes-table/'+id+'/',
          {
            withCredentials:'include',
            crossDomain:true
          })
        .then((response) => {
          if (response.data.error === ''){
            if (response.data.result !== null){
              this.data = response.data.result;
            }
            else{
              this.data = {};
            }
          }
          else{
            if (response.data.error === 'Session is over'){
              setCookie('Authentication','Failed',1);
              this.$router.push('/');
            }
            else{
              this.notifyVue('danger',response.data.error);
            }
            this.dataShow = false;
          }
        })
        .catch((error) => {
          this.notifyVue('danger',error);
        });
    },
    notifyVue(type,message) {
      this.$notify({
        component: NotificationTemplate,
        icon: "tim-icons icon-bell-55",
        horizontalAlign: 'center',
        verticalAlign: 'top',
        type: type,
        message:message,
        timeout: 1500
      });
    },
    prepareData(data){
      this.years = [];
      data = data[this.currentProject];
      this.newIncomesTable = [];
      for (let article in this.articles){
        let key = this.articles[article].name;
        key = key.split(' ').join('_').split('/').join('_').split('.').join('').toLowerCase();
        this.totalIncome = {};
      }
      if (data !== null){
        this.incomeTableFull = this.createIncomeTable(data);
        this.selectedYear = Math.max(...this.years);
      }
      this.newRows = this.incomeTable.length-1;
      this.maxRows = this.newRows + 50;
      this.setTableData();
    },
    setTableData(){
      this.incomeTable = this.incomeTableFull[this.selectedYear] || [];
      this.totalIncome = this.totalIncomeFull[this.selectedYear] || [];
      this.incomeTableOld = JSON.parse(JSON.stringify(this.incomeTable));
      this.newIncomesTable = this.createNewIncomeTable(this.articles, this.maxRows);
    },
    createIncomeTable(data){
      let i = 0;
      let table = {};
      const keys = [];
      for(let day in data) {
        let nextSet = data[day];
        for(let record in nextSet) {
          let line = nextSet[record];
          let dd = new Date(line.date.split('-').join('/') + "");
          const year = dd.getFullYear();
          if (!table[dd.getFullYear()]) {
            table[year] = [];
            this.totalIncomeFull[year] = {};
            if (year) {
              this.years.push(year);
            }
          }

          const obj = {};
          obj['date'] = (dd.getMonth()+1)+'/'+dd.getDate()+'/'+dd.getFullYear();
          for (let article in this.articles){
            let key = this.articles[article].name;
            keys.push(key);
            key = key.split(' ').join('_').split('/').join('_').split('.').join('').toLowerCase();
            obj[key] = this.splitterOfIncomesTable(line[key]);
            if (!this.totalIncomeFull[year][key]) {
              this.totalIncomeFull[year][key] = 0;
            }
            this.totalIncomeFull[year][key] += this.getAmount(obj[key]['value']);
          }
          table[year].push(obj);
        }
      }

      const todayYear = new Date().getFullYear();
      if (!table[todayYear]) {
        this.years.push(todayYear)
        table[todayYear] = [];
        this.totalIncomeFull[todayYear] = {}
        keys.forEach((key) => {
          this.totalIncomeFull[todayYear][key] = 0;
        });

      }

      if (table['NaN']) {
        const temp = table['NaN'];
        delete table['NaN'];
        delete this.totalIncome['NaN']
        Object.values(table).forEach(list => list.unshift(...temp))
      }

      return table;
    },
    createNewIncomeTable(allArticles, maxRow){
      let table = [];
      for(let i = 0; i < maxRow; i++){
        table[i] = {};
        table[i]['date'] = '';
        for (let article in allArticles){
          let key = allArticles[article].name;
          key = key.split(' ').join('_').split('/').join('_').split('.').join('').toLowerCase();
          table[i][key] = {income_id : 0, value : ''};
        }
      }
      return table;
    },

    splitterOfIncomesTable(value){
      if (value === undefined){
        return {income_id:0, value:''};
      }else{
        let tempArr = value.split(':id:');
        let res = {};

        let temp = tempArr[1].split(' - ');
        if (temp.length === 1){
          res = {income_id:tempArr[0], value:value};
        }
        else if (temp.length === 2){
          value = temp[0] + ' - ' +  this.formatter.format(Math.abs(parseInt(temp[1]))/100);
          res = {income_id:tempArr[0], value: value};
        }
        else if (temp.length === 3){
          let resTemp = '';
          if(temp[0] !== ''){
            resTemp+= temp[0] + ' - ';
          }
          if(temp[1] !== ''){
            resTemp+= temp[1] + ' - ';
          }
          if(temp[2] !== ''){
            resTemp+= this.formatter.format(Math.abs(parseInt(temp[2]))/100);
          }
          if (resTemp.substr(resTemp.length-4) === ' - '){
            resTemp = resTemp.substr(0, resTemp.length-4)
          }
          res = {income_id:tempArr[0], value:resTemp};
        }
        else{
          res = {income_id:tempArr[0], value:value};
        }
        return res;
      }
    },
    getAmount(value){
      if (value === '' || value === undefined){ return 0;}
      else{
        let tempArr = value.split(' - ');
        if (tempArr.length === 3){
          value = parseFloat(tempArr[2].replace('$','').replace(',',''));
          return value
        }
        if (tempArr.length === 2){
          value = parseFloat(tempArr[1].replace('$','').replace(',',''));
          return value
        }
        if (tempArr.length === 1){
          value = parseFloat(tempArr[0].replace('$','').replace(',',''));
          return value
        }
      }
    },
    getArticlePropertyName(key){
      return key.split(' ').join('_').split('/').join('_').split('.').join('').toLowerCase();
    },
    addNewInc(event, key){
      let value = 0;
      for (let index in this.incomeTable){
        let income = this.incomeTable[index];
        value += this.getAmount(income[key].value)
      }
      for (let index in this.newIncomesTable){
        let income = this.newIncomesTable[index];
        value += this.getAmount(income[key].value)
      }
      this.$set(this.totalIncome, key, value);
      this.totalIncome = {...this.totalIncome};
    },
    sentIncomeTable(){
      let data = '';
      let lastDate = new Date();
      lastDate = (lastDate.getMonth()+1)+'/'+lastDate.getDate()+'/'+lastDate.getFullYear();
      if (this.incomeTable.length>0){lastDate = this.incomeTable[this.incomeTable.length-1].date;}
      let res = this.parseNewIncomesTable(this.newIncomesTable, lastDate, this.currentProject);
      let upd = this.parseOldIncomesTable(this.incomeTable, this.incomeTableOld, this.currentProject);
      if (res !== '' && upd !== ''){
        data = res.substr(0,res.length-1) + ',' + upd.substr(1);
      }else{
        if (res === ''){
          data = upd;
        }else{
          data = res;
        }
      }
      if (data !== ''){
        axios
          .post(url + 'add-incomes/',
            {data: JSON.parse(data)},
            {
              withCredentials:'include',
              crossDomain:true
            }
          )
          .then((response) => {
            if (response.data.error === ''){
              this.notifyVue('success','The records were added');
              this.getIncomes(this.currentProject).then(res => {
                this.prepareData(this.data);
                this.dataShow = true;
              });
            }
            else{
              if (response.data.error === 'Session is over'){
                setCookie('Authentication','Failed',1);
                this.$router.push('/login');
              }
              else{
                this.notifyVue('danger',response.data.error);
              }
            }
          })
          .catch((error) => {
            this.notifyVue('danger',error);
          })
      }
      else{
        this.notifyVue('info', 'Data was updated');
      }
    },
    parseOldIncomesTable:function(tableValueNew, tableValueOld, project_id){
      let res = '';
      let strOld = JSON.stringify(tableValueOld);
      let strNew = JSON.stringify(tableValueNew);
      if (strNew === strOld){return '';}
      else{
        res = '[';
        for (let index in tableValueNew){
          let recordNew = tableValueNew[index];
          let recordOld = tableValueOld[index];
          if (recordNew.date !== recordOld.date){
            for (let article in this.articles){
              let key = this.articles[article].name;
              key = key.split(' ').join('_').split('/').join('_').split('.').join('').toLowerCase();
              if (recordNew[key]['value'] !== ''){
                res+=this.createIncomeRecord(recordNew[key], project_id, recordNew.date, this.articles[article]['article_id'], this.articles[article]['is_expense']);
              }
            }
          }
          else{
            for (let article in this.articles){
              let key = this.articles[article].name;
              key = key.split(' ').join('_').split('/').join('_').split('.').join('').toLowerCase();
              if (recordNew[key]['value'] !== recordOld[key]['value']){
                res+=this.createIncomeRecord(recordNew[key], project_id, recordNew.date, this.articles[article]['article_id'], this.articles[article]['is_expense']);
              }
            }
          }
        }
        res = res.substr(0,res.length-1) + ']';

        return res;
      }
    },
    createIncomeRecord:function(income,project_id, date, article_id, effect){
      let res = '';
      let value = income.value.split(' - ');
      res+='{';
      res+='"income_id":"' + income.income_id + '",';
      res+='"project_id":"' + project_id + '",';
      res+='"date":"'       + date   + '",';
      let k = 1;
      if (parseInt(effect) === 1){k = -1;}
      if (income.value === ''){
        res+='"is_delete":"1",';
      }
      if (value.length === 2){
        res+='"payee":"'      + value[0]   + '",';
        res+='"amount":"'     + parseFloat(value[1].replace('$','').replace(',',''))*100*k   + '",';
      }
      if (value.length === 3){
        res+='"number":"'     + value[0]   + '",';
        res+='"payee":"'      + value[1]   + '",';
        res+='"amount":"'     + parseFloat(value[2].replace('$','').replace(',',''))*100*k   + '",';
      }
      res+='"article_id":"' + article_id + '"},';
      return res;
    },
    parseNewIncomesTable:function(tableValue, lastDate, project_id){
      let res = '[';
      let dd = new Date(lastDate.split('-').join('/') + "");
      lastDate = (dd.getMonth()+1)+'/'+dd.getDate()+'/'+dd.getFullYear();
      for(let index in tableValue) {
        let line = tableValue[index];
        if (line.date !== ''){
          let dd = new Date(line.date.split('-').join('/'));
          lastDate = (dd.getMonth()+1)+'/'+dd.getDate()+'/'+dd.getFullYear();
        }
        if (lastDate !== ''){
          for (let article in this.articles){
            let key = this.articles[article].name;
            key = key.split(' ').join('_').split('/').join('_').split('.').join('').toLowerCase();
            if (line[key]['value'] !== ''){
              res+=this.createIncomeRecord(line[key], project_id, lastDate, this.articles[article]['article_id'], this.articles[article]['is_expense']);
            }
          }
        }
        else{break;}
      }
      if (res !== '['){res = res.substr(0,res.length-1) + ']';}
      else{res = ''}
      return res;
    },
    scrollingY(e){
      this.$el.querySelector("#incomeTableTitles").scrollLeft = e.srcElement.scrollLeft;
      this.$el.querySelector("#datesValue").scrollTop = e.srcElement.scrollTop;
    },
    changeYear(year) {
      this.selectedYear = year
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },
  destroyed() {
    document.removeEventListener("resize", this.onResize);
  },
  created() {
    document.addEventListener("resize", this.onResize);
    const params = this.$route.query;
    this.currentProject = params.projectId;
    this.projectName = params.projectName.split('_').join(' ');
    if (this.currentProject > 0){
      this.getArticles(this.currentProject).then(res => {
        this.getIncomes(this.currentProject).then(res => {
          this.prepareData(this.data);
          this.dataShow = true;
          let that = this;
          setTimeout(() =>
          {
            let list = document.querySelector("#titles").children;
            list.item(list.length - 1).style.width = "320px";
            that.onResize();
          },100);

        });
      });
    }
  },
}
</script>

<style scoped>
.card{
  margin-top: 0;
}
.handsontable {
  table-layout: fixed;
  position: relative;
}

.handsontable.htAutoColumnSize {
  visibility: hidden;
  left: 0;
  position: absolute;
  top: 0;
}

.handsontable table,
.handsontable tbody,
.handsontable thead,
.handsontable td,
.handsontable th,
.handsontable div {
  box-sizing: content-box;
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
}
.handsontable th {
  position: sticky;
}

.handsontable table.htCore {
  border-collapse: separate;
  /*it must be separate, otherwise there are offset miscalculations in WebKit: http://stackoverflow.com/questions/2655987/border-collapse-differences-in-ff-and-webkit*/
  position: relative;
  /*this actually only changes appearance of user selection - does not make text unselectable
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  -ms-user-select: none;
  /*user-select: none; /*no browser supports unprefixed version*/
  border-spacing: 0;
  margin: 0;
  border-width: 0;
  table-layout: fixed;
  width: 0;
  outline-width: 0;
  /* reset bootstrap table style. for more info see: https://github.com/warpech/jquery-handsontable/issues/224 */
  max-width: none;
  max-height: none;
}

.handsontable col {
  width: 50px;
}

.handsontable col.rowHeader {
  width: 50px;
}

.handsontable th,
.handsontable td {
  border-right: 1px solid #CCC;
  border-bottom: 1px solid #CCC;
  height: 22px;
  empty-cells: show;
  line-height: 21px;
  padding: 0 4px 0 4px;
  /* top, bottom padding different than 0 is handled poorly by FF with HTML5 doctype */
  background-color: #FFF;
  vertical-align: top;
  overflow: hidden;
  outline-width: 0;
  white-space: pre-line;
  /* preserve new line character in cell */
}

.handsontable td.htInvalid {
  -webkit-transition: background 0.75s ease;
  transition: background 0.75s ease;
  background-color: #ff4c42;
}

.handsontable th:last-child {
  /*Foundation framework fix*/
  border-right: 1px solid #CCC;
  border-bottom: 1px solid #CCC;
}

.handsontable tr:first-child th.htNoFrame,
.handsontable th:first-child.htNoFrame,
.handsontable th.htNoFrame {
  border-left-width: 0;
  background-color: white;
  border-color: #FFF;
}

.handsontable th:first-child,
.handsontable td:first-child,
.handsontable .htNoFrame + th,
.handsontable .htNoFrame + td {
  border-left: 1px solid #CCC;
}

.handsontable tr:first-child th,
.handsontable tr:first-child td {
  border-top: 1px solid #CCC;
}

.handsontable thead tr:last-child th {
  border-bottom-width: 0;
}

.handsontable thead tr.lastChild th {
  border-bottom-width: 0;
}

.handsontable th {
  background-color: #EEE;
  color: #222;
  text-align: center;
  font-weight: normal;
  white-space: nowrap;
}

.handsontable thead th {
  padding: 0;
}

.handsontable th.active {
  background-color: #CCC;
}

.handsontable thead th .relative {
  position: relative;
  padding: 2px 4px;
}

/* plugins */

.handsontable .manualColumnMover {
  position: absolute;
  left: 0;
  top: 0;
  background-color: transparent;
  width: 5px;
  height: 25px;
  z-index: 999;
  cursor: move;
}

.handsontable th .manualColumnMover:hover,
.handsontable th .manualColumnMover.active {
  background-color: #88F;
}

.handsontable .manualColumnResizer {
  position: absolute;
  top: 0;
  cursor: col-resize;
}

.handsontable .manualColumnResizerHandle {
  background-color: transparent;
  width: 5px;
  height: 25px;
}

.handsontable .manualColumnResizer:hover .manualColumnResizerHandle,
.handsontable .manualColumnResizer.active .manualColumnResizerHandle {
  background-color: #AAB;
}

.handsontable .manualColumnResizerLine {
  position: absolute;
  right: 0;
  top: 0;
  background-color: #AAB;
  display: none;
  width: 0;
  border-right: 1px dashed #777;
}

.handsontable .manualColumnResizer.active .manualColumnResizerLine {
  display: block;
}

.handsontable .columnSorting:hover {
  text-decoration: underline;
  cursor: pointer;
}

/* border line */

.handsontable .wtBorder {
  position: absolute;
  font-size: 0;
}

.handsontable td.area {
  background-color: #EEF4FF;
}

/* fill handle */

.handsontable .wtBorder.corner {
  font-size: 0;
  cursor: crosshair;
}

.handsontable .htBorder.htFillBorder {
  background: red;
  width: 1px;
  height: 1px;
}

.handsontableInput {
  border: 2px solid #5292F7;
  outline-width: 0;
  margin: 0;
  padding: 1px 4px 0 2px;
  font-family: Arial, Helvetica, sans-serif;
  /*repeat from .handsontable (inherit doesn't work with IE<8) */
  line-height: 1.3em;
  /*repeat from .handsontable (inherit doesn't work with IE<8) */
  font-size: inherit;
  -webkit-box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.4);
  box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.4);
  resize: none;
  /*below are needed to overwrite stuff added by jQuery UI Bootstrap theme*/
  display: inline-block;
  color: #000;
  border-radius: 0;
  background-color: #FFF;
  /*overwrite styles potentionally made by a framework*/
}

.handsontableInputHolder {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
}

.htSelectEditor {
  -webkit-appearance: menulist-button !important;
  position: absolute;
}

/*
TextRenderer readOnly cell
*/

.handsontable .htDimmed {
  color: #777;
}

/*
TextRenderer placeholder value
*/

.handsontable .htPlaceholder {
  color: #999;
}

/*
AutocompleteRenderer down arrow
*/

.handsontable .htAutocompleteArrow {
  float: right;
  font-size: 10px;
  color: #EEE;
  cursor: default;
  width: 16px;
  text-align: center;
}

.handsontable td .htAutocompleteArrow:hover {
  color: #777;
}

/*
CheckboxRenderer
*/

.handsontable .htCheckboxRendererInput.noValue {
  opacity: 0.5;
}

/*
NumericRenderer
*/

.handsontable .htNumeric {
  text-align: right;
}

/*context menu rules*/

ul.context-menu-list {
  color: black;
}

ul.context-menu-list li {
  margin-bottom: 0;
  /*Foundation framework fix*/
}

/**
 * dragdealer
 */

.handsontable .dragdealer {
  position: relative;
  width: 9px;
  height: 9px;
  background: #F8F8F8;
  border: 1px solid #DDD;
}

.handsontable .dragdealer .handle {
  position: absolute;
  width: 9px;
  height: 9px;
  background: #C5C5C5;
}

.handsontable .dragdealer .disabled {
  background: #898989;
}

/**
 * Handsontable in Handsontable
 */

.handsontable .handsontable .wtHider {
  padding: 0 0 5px 0;
}

.handsontable .handsontable table {
  -webkit-box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.4);
  box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.4);
}

/**
 * Handsontable listbox theme
 */

.handsontable.listbox {
  margin: 0;
}

.handsontable.listbox table {
  border: 1px solid #ccc;
  border-collapse: separate;
  background: white;
}

.handsontable.listbox th,
.handsontable.listbox tr:first-child th,
.handsontable.listbox tr:last-child th,
.handsontable.listbox tr:first-child td,
.handsontable.listbox td {
  border-width: 0;
}

.handsontable.listbox th,
.handsontable.listbox td {
  white-space: nowrap;
  text-overflow: ellipsis;
}

.handsontable.listbox td.htDimmed {
  cursor: default;
  color: inherit;
  font-style: inherit;
}

.handsontable.listbox .wtBorder {
  visibility: hidden;
}

.handsontable.listbox tr td.current,
.handsontable.listbox tr:hover td {
  background: #eee;
}

.htContextMenu {
  display: none;
  position: absolute;
}

.htContextMenu table.htCore {
  outline: 1px solid #bbb;
}

.htContextMenu .wtBorder {
  visibility: hidden;
}

.htContextMenu table tbody tr td {
  background: white;
  border-width: 0;
  padding: 4px 6px 0px 6px;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.htContextMenu table tbody tr td:first-child {
  border: 0;
}

.htContextMenu table tbody tr td.htDimmed{
  font-style: normal;
  color: #323232;
}

.htContextMenu table tbody tr td.current{
  background: rgb(233, 233, 233);
}

.htContextMenu table tbody tr td.htSeparator {
  border-top: 1px solid #bbb;
  height: 0;
  padding: 0;
}

.htContextMenu table tbody tr td.htDisabled {
  color: #999;
}

.htContextMenu table tbody tr td.htDisabled:hover {
  background: white;
  color: #999;
  cursor: default;
}

.handsontable td.htSearchResult {
  background: #fcedd9;
  color: #583707;
}

/*WalkontableDebugOverlay*/

.wtDebugHidden {
  display: none;
}

.wtDebugVisible {
  display: block;
  -webkit-animation-duration: 0.5s;
  -webkit-animation-name: wtFadeInFromNone;
  animation-duration: 0.5s;
  animation-name: wtFadeInFromNone;
}

@keyframes wtFadeInFromNone {
  0% {
    display: none;
    opacity: 0;
  }

  1% {
    display: block;
    opacity: 0;
  }

  100% {
    display: block;
    opacity: 1;
  }
}

@-webkit-keyframes wtFadeInFromNone {
  0% {
    display: none;
    opacity: 0;
  }

  1% {
    display: block;
    opacity: 0;
  }

  100% {
    display: block;
    opacity: 1;
  }
}

.handsontable tbody td {
  margin:0; padding:0;
  padding-right:0px;
}

input {
  border:none;
  width:100%;
  height:100%;
  font-family: Verdana, Helvetica, Arial, FreeSans, sans-serif;
  font-size:12px;
  padding: 0 4px 0 4px;

}

input:focus {
  border:2px solid #5292F7;
  outline: none;
  font-weight: 600;
  color: black;
}

select option {
  margin: 40px;
  background: rgb(51, 37, 106);
  color: #fff;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
}

.self-building-square-spinner, .self-building-square-spinner * {
  box-sizing: border-box;
}

.self-building-square-spinner {
  height: 40px;
  width: 40px;

  position: absolute;
  top: 40%;
}

.self-building-square-spinner .square {
  height: 10px;
  width: 10px;
  top: calc( -10px * 2 / 3);
  margin-right: calc(10px / 3);
  margin-top: calc(10px / 3);
  background: #ff1d5e;
  float: left;
  position:relative;
  opacity: 0;
  animation: self-building-square-spinner 6s infinite;
}

.self-building-square-spinner .square:nth-child(1) {
  animation-delay: calc(300ms * 6);
}

.self-building-square-spinner .square:nth-child(2) {
  animation-delay: calc(300ms * 7);
}

.self-building-square-spinner .square:nth-child(3) {
  animation-delay: calc(300ms * 8);
}

.self-building-square-spinner .square:nth-child(4) {
  animation-delay: calc(300ms * 3);
}

.self-building-square-spinner .square:nth-child(5) {
  animation-delay: calc(300ms * 4);
}

.self-building-square-spinner .square:nth-child(6) {
  animation-delay: calc(300ms * 5);
}

.self-building-square-spinner .square:nth-child(7) {
  animation-delay: calc(300ms * 0);
}

.self-building-square-spinner .square:nth-child(8) {
  animation-delay: calc(300ms * 1);
}

.self-building-square-spinner .square:nth-child(9) {
  animation-delay: calc(300ms * 2);
}

.self-building-square-spinner .clear{
  clear: both;
}

.table-fixed-head {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  height: 100vh;
}

.table-fixed-head thead tr {
  display: block;
  position: relative;
}

.table-fixed-head tbody {
  display: block;
  overflow: auto;
  width: 100%;
  height: calc(100vh - 30px);
}

.table-fixed-head tbody tr:nth-child(even) {
  background-color: #DDD;
}

@keyframes self-building-square-spinner {
  0% {
    opacity: 0;
  }
  5% {
    opacity: 1;
    top: 0;
  }
  50.9% {
    opacity: 1;
    top: 0;
  }
  55.9% {
    opacity: 0;
    top: inherit;
  }
}
</style>
